import Icon from "components/Elements/Icon/Icon.tsx";
import ExpiresAfterElement from "../Reusable/ExpiresAfter/ExpiresAfterElement.tsx";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";

const UploaderHeader = ({ listView, setListView }) => {
  const { getUploading } = useUploader();
  const { uploaderGetFiles } = useUploader();

  return getUploading() || uploaderGetFiles().length < 1 ? null : (
    <div className="home-upload-content-header">
      <ExpiresAfterElement />
      <div className="flex-spacer" />

      <div className="view-grid-ui">
        <div
          className={`view-icon-wrapper ${!listView ? " selected" : ""}`}
          onClick={() => {
            setListView(false);
          }}
        >
          <Icon name={"home/thumbreview_icon"} />
        </div>
        <div
          className={`view-icon-wrapper ${listView ? " selected" : ""}`}
          onClick={() => {
            setListView(true);
          }}
        >
          <Icon name={"home/listpreview_icon"} />
        </div>
      </div>
    </div>
  );
};
export default UploaderHeader;
